<template>
  <ListingBlockLayout
    :class="`listing-block--${view.cssClassModifier}`"
    :title="view.pageTitle()"
    :viewAllLink="view.viewAllLink"
    :viewAllText="view.viewAllText"
  >
    <ListCard
      v-for="doc in docs"
      :key="doc.id"
      :view="view"
      :doc="doc"
      v-bind="cardProps"
      @click="trackDocView($event, doc)"
    />
  </ListingBlockLayout>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

import { Mixpanel } from '@/analytics/mixpanel'
import { ListView } from '@/models/docs.list'
import { ListItem } from '@/models/interfaces'

import ListingBlockLayout from './ListingBlockLayout.vue'
import ListCard from './ListCard.vue'

const props = defineProps<{
  view: ListView
  docs: ListItem[]
  cardProps?: Record<string, any>
}>()

const router = useRouter()

function trackDocView(event: Event, doc: ListItem): void {
  try {
    Mixpanel.trackDocView(
      event,
      props.view.pageTitle(),
      router.currentRoute.value.fullPath,
      doc,
    )
  } catch (error) {
    // Unexpected error in the Mixpanel tracking
    console.error(error)
    return
  }
}
</script>
